/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * NOT_IN operator looks for values that are not in the given list of values.
 */
export interface NotInKeyType {
    /** The values to compare against. */
    values: Truvity.NotInKeyTypeValuesItem[];
}
